<template>
  <li
    :class="clContainer(notification.read ? 'read' : 'unread')"
    :key="notification.id"
  >
    <button
      :class="clSub('remove')"
      @click="$emit('remove', index)"
      :title="__('#main.components.notifications.buttons.remove_item.title')"
    >
      <img src="../../../img/icons/cross.svg" />
    </button>

    <div :class="clSub('top')">
      <div v-if="notification.data" :class="clSub('data')">
        <p v-for="(dataGroup, key) in notification.data" :key="key">
          <span
            v-for="(data, index) in getDataGroupItems(dataGroup)"
            :key="index"
          >
            <a
              v-if="typeof data == 'object'"
              :is="data.url ? 'a' : 'button'"
              :href="data.url"
              :title="__(`data.titles.${key}`, '')"
              style="color: #111"
              @click="
                action(
                  data.action,
                  'actionData' in data ? data.actionData : data
                )
              "
            >
              <span
                v-html="
                  __(`data.labels.${key}`, '') +
                  __(`data.text.${key}`, data, data.text)
                "
              ></span>
            </a>
            <template v-else>
              <span v-tif="`data.labels.${key}`"></span>
              {{ data }}
            </template>
          </span>
        </p>
      </div>

      <div v-if="notification.date" :class="clSub('date')">
        {{ notification.date }}
      </div>
    </div>

    <div
      :class="clSub('text')"
      v-html="__(`text.${notification.typeKey}`, notification, '')"
    ></div>

    <div
      v-for="(text, index) in notification.additionalText || []"
      :class="clSub('text', text.class || '')"
      :key="index"
      v-html="text.text || text"
    ></div>

    <ul :class="clSub('actions')" v-if="notification.actions">
      <template v-for="(action, key) in notification.actions">
        <li v-if="!('showButton' in action) || action.showButton" :key="key">
          <a
            :is="action.url ? 'a' : 'button'"
            :href="action.url"
            class="btn btn-secondary btn-small"
            @click="action(key, action)"
          >
            {{ __(`actions.${key}`, action) }}
          </a>
        </li>
      </template>
    </ul>

    <div :class="clSub('bottom')">
      <div
        :class="clSub('title')"
        v-tif="`title.${notification.typeKey}`"
      ></div>

      <div :class="clSub('source')" v-if="notification.source">
        <a
          :is="notification.trigger.url ? 'a' : 'span'"
          :href="notification.trigger.url"
        >
          {{ notification.trigger.name }}
        </a>
      </div>

      <div :class="clSub('icon')" v-if="notification.icon">
        <img :src="getIconSrc(`${notification.icon}.svg`)" />
      </div>
    </div>
  </li>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";
import NeedsSetableCssClasses from "../Mixins/NeedsSetableCssClasses";

export default {
  mixins: [NeedsIcons, NeedsSetableCssClasses],
  props: {
    notification: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
    },
    baseAppUrl: {
      type: String,
    },
  },
  computed: {
    translationsKeyPaths() {
      return [
        `notifications.common`,
        `notifications.${this.notification.namespace}.common`,
        `notifications.${this.notification.namespace}.${this.notification.typeKey}`,
        `notifications.${this.notification.namespace}.${this.notification.categoryKey}`,
      ];
    },
  },
  methods: {
    action(actionKey, actionData) {
      if (this.baseAppUrl) {
        window.location.href = "/jobs/assembling/" + actionData;
        return;
      }

      this.$emit("action", {
        notification: this.notification,
        actionKey,
        actionData,
      });
    },
    getDataGroupItems(dataGroup) {
      return Array.isArray(dataGroup) ? dataGroup : [dataGroup];
    },
  },
};
</script>
<style scoped>
a,
button {
  color: #111;
}
</style>